// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconMusic = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M30.608 8.00446C29.6364 7.94233 29 8.53327 29 9.5069V36.3221C26.2875 34.7422 23.0032 34 19.9099 34C13.73 34 10 37.4129 10 43.3046C10 52.1536 18.0428 56 25.0901 56C31.27 56 35 52.5871 35 46.6953V26C41.7532 26 48.757 30.4959 49.5521 38.827C49.6901 40.2739 51.3617 40.5779 52 39.2917C52.6329 38.0164 54 35.0369 54 30.5015C54 16.5888 41.6008 8.70747 30.608 8.00446Z" />
    </svg>
  );
};
